// extracted by mini-css-extract-plugin
module.exports = {"header":"_1PAPR","back":"_1gdDU","hidden":"_1-VvC","big":"_3xey0","logo":"_3leNd"};